import { Body, Controller, Post, UploadedFiles, UseInterceptors } from "@nestjs/common";
import { ApiBody, ApiTags } from "@nestjs/swagger";
import { VehicleReqService } from "./vehicle-req-service";
import { ApplicationExceptionHandler } from "@project-management-system/backend-utils";
import { AssignVendor, CommonResponseModel, DriverUpdateReq, VehicleTypeReq as vehicleType,TripReq, VehicleIdReq, VehicleRequest, roleReq } from "@project-management-system/shared-models";
import { VehicleReqDto } from "packages/libs/shared-models/src/common/vms/vehicle-req/vehicle-req-dto";
import { FilesInterceptor } from '@nestjs/platform-express';
import { diskStorage } from 'multer';
import { DatesDto } from "./dto/dates.dto";
import { DepartmentIdReq } from "./dto/department-id.req";
import { Cron } from "@nestjs/schedule";
import { VehicleTypeReq as vehReq } from "../vehicle/vehicle-type.req";
import { VehicleReqId } from "./dto/vehicle-req-id";
@Controller('vehicle_req')
@ApiTags('/vehicle_req')
export class VehiclereqController{
    constructor(
        private vehicleServie:VehicleReqService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler

    ){}

    @Post('/createVehiclerequest')
    @ApiBody({ type: VehicleReqDto })
    async createVehiclerequest(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.vehicleServie.createVehiclerequest(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }
    @Post('/getAllDeptWiseVehcieReq')
    async getAllDeptWiseVehcieReq(@Body() req:any):Promise<CommonResponseModel>{
        try{
            return await this.vehicleServie.getAllDeptWiseVehcieReq(req)
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponseModel,err)
        }
    }
    @Post('/updateHodApproval')
    async updateHodApproval(@Body() req:any):Promise<CommonResponseModel>{
        try{
            return await this.vehicleServie.updateHodApproval(req)
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponseModel,err)
        }
    }

    @Post('/getAllVehiclerequest')
    async getAllVehiclerequest(@Body() req:any):Promise<CommonResponseModel>{
        try{
        return await this.vehicleServie.getAllVehiclerequest(req)
        }
        catch(err){
        return this.applicationExceptionHandler.returnException(CommonResponseModel,err)
        }
    }

    @Post('/getAdminApproval')
    async getAdminApproval(@Body() req:any):Promise<CommonResponseModel>{
        try{
            return await this.vehicleServie.getAdminApproval(req)
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponseModel,err)
        }
    }

    @Post('/updateAdminRejection')
    async updateAdminRejection(@Body() req:any):Promise<CommonResponseModel>{
        try{
            return await this.vehicleServie.updateAdminRejection(req)
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponseModel,err)
        }
    }

    @Post('/updateAdminApproveData')
    async updateAdminApproveData(@Body() req:any):Promise<CommonResponseModel>{
        try{
            return await this.vehicleServie.updateAdminApproveData(req)
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponseModel,err)
        }
    }

    @Post('/getAllVendorDetails')
    async getAllVendorDetails(@Body() req:any):Promise<CommonResponseModel>{
        try{
            return await this.vehicleServie.getAllVendorDetails(req)
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponseModel,err)
        }
    }
    @Post('/updateVendorVehicelAssin')
    async updateVendorVehicelAssin(@Body() req:any):Promise<CommonResponseModel>{
        try{
            return await this.vehicleServie.updateVendorVehicelAssin(req)
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponseModel,err)
        }
    }

    @Post('/updateVendorVehicelDriverAssin')
    async updateVendorVehicelDriverAssin(@Body() req:any):Promise<CommonResponseModel>{
        try{
            return await this.vehicleServie.updateVendorVehicelDriverAssin(req)
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponseModel,err)
        }
    }

    @Post('/rejectVehicleReq')
    async rejectVehicleReq(@Body() req:any):Promise<CommonResponseModel>{
        try{
            return await this.vehicleServie.rejectVehicleReq(req)
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponseModel,err)
        }
    }
    @Post('/getVehicleReqReportData')
    async getVehicleReqReportData(@Body() req:any):Promise<CommonResponseModel>{
        try{
            return await this.vehicleServie.getVehicleReqReportData(req)
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponseModel,err)
        }
    }

    @Post('/getAssignedVehicleDetails')
    @ApiBody({ type: vehReq })
    async getAssignedVehicleDetails(@Body() req:any):Promise<CommonResponseModel>{
        try{
            return await this.vehicleServie.getAssignedVehicleDetails(req)
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponseModel,err)
        }
    }


    @Post('/getVehicleReportData')
    async getVehicleReportData():Promise<CommonResponseModel>{
        try{
            return await this.vehicleServie.getVehicleReportData()
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponseModel,err)
        }
    }
    @Post('/getvehicledropdown')
    async getvehicledropdown(req?: VehicleRequest):Promise<CommonResponseModel>{
        try{
            return await this.vehicleServie.getvehicledropdown(req)
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponseModel,err)
        }
    }
    @Post('/getAdmindropdown')
    async getAdmindropdown(req?: VehicleRequest):Promise<CommonResponseModel>{
        try{
            return await this.vehicleServie.getAdmindropdown(req)
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponseModel,err)
        }
    }
    @Post('/getHoddropdown')
    async getHoddropdown(req?: VehicleRequest):Promise<CommonResponseModel>{
        try{
            return await this.vehicleServie.getHoddropdown(req)
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponseModel,err)
        }
    }
    @Post('/updateTripDetails')
    async updateTripDetails(@Body() req:any):Promise<CommonResponseModel>{
        console.log(req,"controll")
        try{
            return await this.vehicleServie.updateTripDetails(req)
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponseModel,err)
        }
    }

    @Post('/getAssignedVehicles')
    async getAssignedVehicles():Promise<CommonResponseModel>{
        try{
            return await this.vehicleServie.getAssignedVehicles()
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponseModel,err)
        }
    }

    @Post('/getAssignedVehiclesByVehicleType')
    @ApiBody({ type:vehicleType})
    async getAssignedVehiclesByVehicleType(@Body() req:any):Promise<CommonResponseModel>{
        try{
            return await this.vehicleServie.getAssignedVehiclesByVehicleType(req)
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponseModel,err)
        }
    }

    //Dashboard API
    @Post('/getVehicleReqStatusCount')
    async getVehicleReqStatusCount():Promise<CommonResponseModel>{
        try{
            return await this.vehicleServie.getVehicleReqStatusCount()
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponseModel,err)
        }
    }

     //Dashboard API
     @Post('/getTotalVehiclesCount')
     async getTotalVehiclesCount():Promise<CommonResponseModel>{
         try{
             return await this.vehicleServie.getTotalVehiclesCount()
         }catch(err){
             return this.applicationExceptionHandler.returnException(CommonResponseModel,err)
         }
     }

     //Dashboard API
     @Post('/getVehicleSummary')
     @ApiBody({ type: DatesDto })
     async getVehicleSummary(@Body() req:any):Promise<CommonResponseModel>{
         try{
             return await this.vehicleServie.getVehicleSummary(req)
         }catch(err){
             return this.applicationExceptionHandler.returnException(CommonResponseModel,err)
         }
     }

      //Dashboard API
      @Post('/getVehicleRenwalsData')
      async getVehicleRenwalsData():Promise<CommonResponseModel>{
          try{
              return await this.vehicleServie.getVehicleRenwalsData()
          }catch(err){
              return this.applicationExceptionHandler.returnException(CommonResponseModel,err)
          }
      }


       //Dashboard API
       @Post('/getBudgetVSExpenditure')
        @ApiBody({ type: DatesDto })
       async getBudgetVSExpenditure(@Body() req:any):Promise<CommonResponseModel>{
           try{
               return await this.vehicleServie.getBudgetVSExpenditure(req)
           }catch(err){
               return this.applicationExceptionHandler.returnException(CommonResponseModel,err)
           }
       }

       //Dashboard API
       @Post('/getMonthsBetweenDates')
       async getMonthsBetweenDates() {
        const startDate = new Date('2022-01-01');
        const endDate = new Date('2022-06-30');
        return this.vehicleServie.getMonthsBetweenDates(startDate, endDate);
      }

      //Dashboard API
      @Post('/getDatesInMonth')
      getDatesInMonth() {
        const year = 2024;
        const month = 8;
        return this.vehicleServie.getDatesInMonth(year, month);
      }

    @Post('/getVehicleAvaialbleVSOccupied')
    @ApiBody({ type: DatesDto })
    async getVehicleAvaialbleVSOccupied(@Body() req:any):Promise<CommonResponseModel>{
        try{
            return await this.vehicleServie.getVehicleAvaialbleVSOccupied(req)
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponseModel,err)
        }
    }

    @Post('/getVehicleIssueStatus')
    async getVehicleIssueStatus():Promise<CommonResponseModel>{
        try{
            return await this.vehicleServie.getVehicleIssueStatus()
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponseModel,err)
        }
    }

    @Post('/getTop5VehicleIssues')
    async getTop5VehicleIssues():Promise<CommonResponseModel>{
        try{
            return await this.vehicleServie.getTop5VehicleIssues()
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponseModel,err)
        }
    }

    @Post('/getTop5RenwalVehicles')
    async getTop5RenwalVehicles():Promise<CommonResponseModel>{
        try{
            return await this.vehicleServie.getTop5RenwalVehicles()
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponseModel,err)
        }
    }

    @Post('/getTop5ServiceInprogress')
    async getTop5ServiceInprogress():Promise<CommonResponseModel>{
        try{
            return await this.vehicleServie.getTop5ServiceInprogress()
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponseModel,err)
        }
    }

    @Post('/getVendorsInfo')
    @ApiBody({ type: DatesDto })
    async getVendorsInfo(@Body() req:any):Promise<CommonResponseModel>{
        try{
            return await this.vehicleServie.getVendorsInfo(req)
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponseModel,err)
        }
    }

    @Post('/RejectionsData')
    @ApiBody({ type: DatesDto })
    async RejectionsData(@Body() req:any):Promise<CommonResponseModel>{
        try{
            return await this.vehicleServie.RejectionsData(req)
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponseModel,err)
        }
    }

    @Post('/getServicePendingAge')
    async getServicePendingAge():Promise<CommonResponseModel>{
        try{
            return await this.vehicleServie.getServicePendingAge()
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponseModel,err)
        }
    }

    @Post('/getRequestRateAndPendingApprovals')
    @ApiBody({ type: DatesDto })
    async getRequestRateAndPendingApprovals(@Body() req:any):Promise<CommonResponseModel>{
        try{
            return await this.vehicleServie.getRequestRateAndPendingApprovals(req)
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponseModel,err)
        }
    }

    @Post('/getDepartmentWiseStatus')
    async getDepartmentWiseStatus():Promise<CommonResponseModel>{
        try{
            return await this.vehicleServie.getDepartmentWiseStatus()
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponseModel,err)
        }
    }

    @Post('/getTop5TripDetailsOfDept')
    @ApiBody({ type: DepartmentIdReq })
    async getTop5TripDetailsOfDept(@Body() req:any):Promise<CommonResponseModel>{
        try{
            return await this.vehicleServie.getTop5TripDetailsOfDept(req)
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponseModel,err)
        }
    }

    @Post('/getScheduledTripsOnMonth')
    @ApiBody({ type: DatesDto })
    async getScheduledTripsOnMonth(@Body() req:any):Promise<CommonResponseModel>{
        try{
            return await this.vehicleServie.getScheduledTripsOnMonth(req)
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponseModel,err)
        }
    }

    @Post('/getBudgetVSExpenditureDeptWise')
    async getBudgetVSExpenditureDeptWise():Promise<CommonResponseModel>{
        try{
            return await this.vehicleServie.getBudgetVSExpenditureDeptWise()
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponseModel,err)
        }
    }

    // @Post('/createTripDetails')
    // async createTripDetails(@Body() req: TripReq): Promise<CommonResponseModel> {
    //     try {
    //         return await this.vehicleServie.createTripDetails(req);
    //     } catch (error) {
    //         return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
    //     }
    // }

    @Cron('*/5 * * * *')
    @Post('/updateHodToApproved')
    async updateHodToApproved(): Promise<CommonResponseModel> {
        try {
        return await this.vehicleServie.updateHodToApproved()
        }
        catch (err) {
        return this.applicationExceptionHandler.returnException(CommonResponseModel, err);
        }
    }


    @Post('/getVehicleDetailsByReqId')
    @ApiBody({ type: VehicleReqId })
    async getVehicleDetailsByReqId(@Body() req:any): Promise<CommonResponseModel> {
        try {
            console.log(req)
        return await this.vehicleServie.getVehicleDetailsByReqId(req)
        }
        catch (err) {
        return this.applicationExceptionHandler.returnException(CommonResponseModel, err);
        }
    }

    @Post('/getAllDetailsToUpdateDriver')
    @ApiBody({ type: DriverUpdateReq })
    async getAllDetailsToUpdateDriver(@Body() req:any): Promise<CommonResponseModel> {
        try {
            console.log(req)
        return await this.vehicleServie.getAllDetailsToUpdateDriver(req)
        }
        catch (err) {
        return this.applicationExceptionHandler.returnException(CommonResponseModel, err);
        }
    }
    @Post('/getAllDriversToUpdate')
    @ApiBody({ type: DriverUpdateReq })
    async getAllDriversToUpdate(@Body() req:any): Promise<CommonResponseModel> {
        try {
            console.log(req)
        return await this.vehicleServie.getAllDriversToUpdate(req)
        }
        catch (err) {
        return this.applicationExceptionHandler.returnException(CommonResponseModel, err);
        }
    }
    @Post('/updateDriver')
    @ApiBody({ type: DriverUpdateReq })
    async updateDriver(@Body() req:any): Promise<CommonResponseModel> {
        try {
            console.log(req)
        return await this.vehicleServie.updateDriver(req)
        }
        catch (err) {
        return this.applicationExceptionHandler.returnException(CommonResponseModel, err);
        }
    }
    @Post('/assignRequestToVendor')
    @ApiBody({ type: AssignVendor })
    async assignRequestToVendor(@Body() req:any): Promise<CommonResponseModel> {
        try {
        return await this.vehicleServie.assignRequestToVendor(req)
        }
        catch (err) {
        return this.applicationExceptionHandler.returnException(CommonResponseModel, err);
        }
    }

}